/* eslint-disable */
export const maxLifetime = 29

export default [
[0, 100000],
[1, 70000],
[2, 69419],
[3, 68961],
[4, 68533],
[5, 68129],
[6, 67502],
[7, 66665],
[8, 65618],
[9, 63742],
[10, 61167],
[11, 57429],
[12, 52732],
[13, 46304],
[14, 38839],
[15, 29937],
[16, 20459],
[17, 12198],
[18, 6255],
[19, 2361],
[20, 770],
[21, 282],
[22, 76],
[23, 21],
[24, 6],
[25, 2],
[26, 1],
[27, 1],
[28, 1],
[29, 1],
[30, 0]
// [31, 0],
// [32, 0]
]
